import * as React from "react";

const Layout: React.FC<{
	desktopFilters: React.ReactNode;
	mobileFilters: React.ReactNode;
	comparisonTable: React.ReactNode;
	loadMore: React.ReactNode;
	sorter: React.ReactNode;
}> = ({ desktopFilters, mobileFilters, comparisonTable, loadMore, sorter }) => {
	return (
		<section className="flex-grow-1 bg-blue">
			<div className="d-flex flex-column flex-grow-1 align-items-center pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-3 d-none d-lg-inline">{desktopFilters}</div>
						<div className="col-lg-9 col-12">
							<div className="row mb-3">
								<div className="col-md d-md-flex d-none align-items-center text-start mb-4 mb-lg-0"></div>
								<div className="col-12 col-md text-center text-lg-end mb-3 mb-lg-0">
									{sorter}
								</div>
								<div className="col-12 d-flex text-center justify-content-center align-items-center d-md-none">
									<label className="font-weight-500 pe-3">Filter by</label>
									<div className="select__container w-75">{mobileFilters}</div>
								</div>
							</div>
							<div>{comparisonTable}</div>
							<div className="col-12 mt-3">{loadMore}</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Layout;
